import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 12, fill: "currentColor", opacity: 0.2 }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10.09 4.744a.833.833 0 0 1 0 1.179l-1.911 1.91H17A.833.833 0 0 1 17 9.5H8.18l1.91 1.91a.833.833 0 1 1-1.178 1.18L5.578 9.255a.833.833 0 0 1 0-1.179L8.91 4.744a.833.833 0 0 1 1.178 0m3.82 6.667a.833.833 0 0 1 1.18 0l3.333 3.333a.833.833 0 0 1 0 1.179l-3.334 3.333a.833.833 0 1 1-1.178-1.179l1.91-1.91h-8.82A.833.833 0 0 1 7 14.5h8.82l-1.91-1.91a.834.834 0 0 1 0-1.18",
      clipRule: "evenodd"
    }
  )
);
var SvgCircledBidirectionalArrowFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CircledBidirectionalArrowFilled_default = SvgCircledBidirectionalArrowFilled;

export { CircledBidirectionalArrowFilled_default as default };
